<template>
  <TransitionRoot as="div" :show="open">
    <Dialog as="div" class="fixed z-20 inset-0 overflow-y-auto" @close="closeModal">
      <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 sm:block sm:p-0">
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="ease-in duration-200"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </TransitionChild>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
          &#8203;
        </span>
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to="opacity-100 translate-y-0 sm:scale-100"
          leave="ease-in duration-200"
          leave-from="opacity-100 translate-y-0 sm:scale-100"
          leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <div
            class="
              bg-white
              absolute
              top-1/2
              rounded-lg
              z-30
              w-full
              max-w-xl
              py-6
              pl-6
              pr-8
              left-1/2
              transform
              -translate-x-1/2 -translate-y-1/2
            "
          >
            <WifiConfigurationWizard @close="closeModal" />
          </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import { Dialog, DialogOverlay, TransitionChild, TransitionRoot } from '@headlessui/vue';
import WifiConfigurationWizard from '@/Components/Devices/WifiConfigurationWizard.vue';

export default {
  components: {
    Dialog,
    DialogOverlay,
    TransitionChild,
    TransitionRoot,
    WifiConfigurationWizard,
  },
  emits: ['closeWifiConfigurationModal'],
  props: {
    open: {
      type: Boolean,
    },
  },
  setup(_, { emit }) {
    const closeModal = () => {
      emit('closeWifiConfigurationModal');
    };
    return {
      closeModal,
    };
  },
};
</script>
